'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DropdownMenuItem;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DropdownMenuItem(_ref) {
  var children = _ref.children,
      className = _ref.className;

  return _react2.default.createElement(
    'li',
    { role: 'option', className: 'menu-item ' + className },
    children
  );
}

DropdownMenuItem.propTypes = {
  children: _bcPropTypes.childrenShape.isRequired,
  className: _react2.default.PropTypes.string
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-dropdown/lib/components/dropdown-menu/components/DropdownMenuItem.component.js
// module id = 1074
// module chunks = 1